import { Constructor } from "../types/constructor";

export interface ILockable {
    isLocked: boolean;

    lock(): void;
    unlock(): void;
}

export function LockMixin<TBaseClass extends Constructor<any>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<ILockable> {

    class LockableExtension extends BaseClass implements ILockable {
        private _isLocked: boolean;

        public get isLocked(): boolean {
            return this._isLocked;
        }

        public lock(): void {
            this._isLocked = true;
        }

        public unlock(): void {
            this._isLocked = false;
        }
    }

    return LockableExtension;
}
